import { IProps } from "@/typings/utils";
import { Component } from "react";
import { CouponInfoModleList, ICoupon, ICouponResponse, INewUserPage, IRenderStatus, IState, IUserType } from './typing';

import BannerAndRank from './comp/banner-and-rank';
import classnames from 'classnames';
import HeaderBack from './comp/header';
import ICouponList from './comp/coupon-list';
import ProductFlow from './comp/goods-feed';
import styles from './index.module.less';
import TimeCountDown from './comp/time-count-down';
import { Toast } from "antd-mobile";
import { oldUserMsg1, oldUserMsg2, successMsgMap } from "./config/lang";
import { linear, YBackGroundImage } from "@/utils/style-methods";
import { getCouponDetail, getUser, receiveCoupon } from "./api";
import { imgResource } from "./config/resource";
import Jockeys from "@/utils/jockey";
// 特殊的分享埋点，因为事件名称重复了
import {  createTrackConfig } from './config/track-config-share';
import { withReactTrack } from "@du/analytics-sdk";
import { isDuApp } from "@/utils/appUtils/getDevice";

type IPropsNewUser = IProps<INewUserPage>;

/**
 * 新老用户处理逻辑放在组件外面，因为老用户除了商品流根本就不用渲染；
 * 不用函数式的原因：react开发时间2周😭
 */
// lint出问题，绝对是因为改了规则，本来说是用airbnb的
@withReactTrack({ createTrackConfig})
class PoizonNewUserCouponV3 extends Component<IPropsNewUser, IState> {
    static config: {
        name: string;
    }

    constructor(props: IPropsNewUser) {
        super(props);
        if (!props.propsConfig) {
            this.state = {
                renderStatus: IRenderStatus.fail,
                expiredTime: 0,
                sellerTabList: [],
                buyerTabList: [],
                background: {},
            }
        } else {
            this.state = {
                expiredTime: 0,
                sellerTabList: [],
                buyerTabList: [],
                background: {},
                renderStatus: IRenderStatus.start,
                ...props.propsConfig,
            }
        }
    }
    // 数据准备完成之后开始渲染
    async componentDidMount() {
        try {
            const { lang } = this.props.editConfig;
            // 1. 确定用户身份
            let userType = await this.checkNewUser();
            // 2. 获取优惠券信息
            const couponInfo = await this.couponDeal(userType);
            
            // 这里2个接口的定义还不一样，state有坑指的是可以领取
            if (userType !== IUserType.none) {
                if (couponInfo.state === 1) {
                    Toast.info(successMsgMap[lang]);
                }

                Jockeys.receiveH5Data('adActivity', {
                    advType: 11,
                    state: couponInfo.state,
                });
            }

            // 展示的逻辑，如果用户领取时候是新用户，需要保证用户可以继续领取
            // 兼容逻辑，如果不存在couponInfo.drawUserIdentity，需要checkNewUser兜底
            if (couponInfo.drawUserIdentity) {
                userType = this.mergeUserInfo(couponInfo.drawUserIdentity);
            }

            this.bindShareEvent();
            // 强制给7天倒计时
            const expiredTime = (couponInfo.countDownExpireTime || Date.now() + 24 * 3600 * 1000);
            let expired = false;

            if (Date.now() > expiredTime || couponInfo.state === 3) expired = true;
            // 1 领取成功(包括已领取)；2 非新用户；3 已过期 4 未登录 5 已领完 6 已领取
            if ( couponInfo.state === 1) Toast.info(successMsgMap[lang])

            this.setState({
                renderStatus: IRenderStatus.ready,
                userType,
                expiredTime,
                expired,
                // 领取状态
                couponStatus: couponInfo.state,
                couponList: this.minxCouponInfo(couponInfo.couponInfoModleList, this.state.couponList || []),
                renderUserType: userType === IUserType.seller ? IUserType.seller : IUserType.buyer,
            });
        } catch (e) {
            this.setState({
                renderStatus: IRenderStatus.fail,
                expiredTime: 0,
            });
        }
    }

    async componentWillUnmount() {
        this.removeShareEvent()
    }

    mergeUserInfo(data: {
        newBuyer: boolean
        newSeller: boolean
        regionOpenBuyer: boolean
        regionOpenSeller: boolean
    }) {
        let userType = IUserType.none;
        if (data === undefined) return userType;

        const isSeller = data.newSeller && data.regionOpenSeller;
        const isBuyer = data.newBuyer && data.regionOpenBuyer;
        if (isSeller && isBuyer) {
            userType = IUserType.all;
        } else if (isSeller) {
            userType = IUserType.seller;
        } else if (isBuyer) {
            userType = IUserType.buyer;
        } else {
            userType = IUserType.none;
        }

        return userType;
    }

    bindShareEvent() {
        if (!document.querySelector('#share')) return
        document.querySelector('#share').addEventListener('click', () => {
            (this as any).$track('poizon_activity_sign_block_click')
        })
    }

    removeShareEvent() {
        if (!document.querySelector('#share')) return
        document.querySelector('#share').removeEventListener('click', () => {
            (this as any).$track('poizon_activity_sign_block_click')
        })
    }

    couponDeal(userType: IUserType): Promise<ICouponResponse> {
        if (userType !== IUserType.none) {
            return this.orderCoupon();
        } else {
            // 特殊的，不执行领取
            return this.couponInfo();
        }
    }

    minxCouponInfo(couponInfoNetWork: CouponInfoModleList[] = [], couponInfoOrigin: ICoupon[]): ICoupon[] {
        const kv = {};

        couponInfoNetWork.forEach(item => {
            kv[item.templateId] = item;
        });
        
        return couponInfoOrigin.map(item => {
            return {
                ...item,
                ...kv[item.id],
            }
        })
    }
    // 优惠券领取
    async orderCoupon(): Promise<ICouponResponse> {
        const { lang, local } = this.props.editConfig;
        return await receiveCoupon({
            countryCode: local,
            language: lang,
            marketingType: 3,
            uniqueMark: this.props.pageId,
        }).catch(() => {
            return {
                couponInfoModleList: [],
                expireTime: 0,
                marketingId: -1,
                state: -1,
            }
        })
    }
    // 优惠券数据
    async couponInfo(): Promise<ICouponResponse> {
        const { lang, local } = this.props.editConfig;

        return await getCouponDetail({
            countryCode: local,
            language: lang,
            marketingType: 3,
            uniqueMark: this.props.pageId,
        }).catch(() => {
            return {
                data: [],
                expireTime: 0,
                marketingId: -1,
                state: -1,
            };
        });
    }
    // 用户身份数据
    async checkNewUser() {
        let userType = IUserType.all;
        const { lang, local } = this.props.editConfig;
        const data = await getUser({
            countryCode: local,
            language: lang,
            region: local,
        }).catch((e) => {
            if (e.code === 700) {
                userType = IUserType.none
            }
        })
        if (data && data.data) {
            const isSeller = data.data.newSeller && data.data.regionOpenSeller;
            const isBuyer = data.data.newBuyer && data.data.regionOpenBuyer;

            if (isSeller && isBuyer) {
                userType = IUserType.all;
            } else if (isSeller) {
                userType = IUserType.seller;
            } else if (isBuyer) {
                userType = IUserType.buyer;
            } else {
                userType = IUserType.none;
            }
        }

        return userType;
    }

    changeUserType(userType: IUserType) {
        this.setState({ renderUserType: userType });
    }
    // 老用户，省的麻烦，没有独立出去
    oldUserRender() {
        const { lang } = this.props.editConfig
        const { countTimeFixedColor } = this.state.pageColor
        const footerImage = YBackGroundImage(imgResource["footer-back"], [{
            mode: 'resize',
            width: 3 * 175,
        }])

        return (
            <>
                <div className={styles['old-user-info']} style={{color: countTimeFixedColor}}>
                    <div className={styles['time-render-text']}>{oldUserMsg1[lang]}</div>
                    <div className={styles['time-render-text']}>{oldUserMsg2[lang]}</div>
                </div>
                <div className={classnames([{
                    [styles['footer-img']]: true,
                    [styles['footer-no-pos']]: true,
                }])} style={{ ...footerImage }}></div>
            </>
        )
    }

    render() {
        const {
            renderStatus,
            background,
            userType,
            couponList,
            renderUserType,
            buttonName,
            bannerList,
            expiredTime,
            expired,
            ruleUrl,
            pageColor,
            sellerTabList,
            buyerTabList,
            tabTextColorActive,
            tabTextColor,
            tabBgColor,
            tabItemTitleBg,
            tabCount,
            couponStatus,
            rankList
        } = this.state;
        const { lang, local: region } = this.props.editConfig;
        // todo: 用户第一次刷新的时候会出现奇怪的显示，这个需要处理
        if (renderStatus === IRenderStatus.start) return (<div></div>);
        if (renderStatus === IRenderStatus.fail) return (<div> 请在左侧输入数据后查看 </div>);
        
        return (
            <div id='container' className={styles['container']}>
                <div className={styles['top-area']}
                    style={ renderUserType === IUserType.buyer ? linear(background.topBackColor) : linear(background.sellerTopBackColor || background.topBackColor) }>
                    {/* 头部背景图 */}
                    <HeaderBack {...this.state.background}></HeaderBack>
                    <div className={styles['top-area-content']}>
                        {
                            // 如果已过期直接展示老用户逻辑
                            (userType !== IUserType.none || !isDuApp()) && couponStatus !== 2
                                ? (
                                    <>
                                        {/* 倒计时， notice：使用了IntersectionObserver*/}
                                        {<TimeCountDown
                                            pageColor={pageColor}
                                            tabBgColor={tabBgColor}
                                            expireTime={isDuApp() ? expiredTime : Date.now() + 7 * 24 * 3600 * 1000}
                                            expired={expired}
                                            lang={lang}
                                            region={region}
                                            ruleUrl={ruleUrl}
                                            limitAmount={4000}
                                            couponType={1}
                                            deductionAmount={100}
                                        />}
                                        {/* 按钮区域 & 优惠券 */}
                                        <ICouponList
                                            couponStatus={couponStatus}
                                            pageColor={pageColor}
                                            buttonName={buttonName}
                                            changeUserType={(userType) => this.changeUserType(userType)}
                                            couponList={couponList}
                                            lang={lang}
                                            renderUserType={renderUserType}
                                            userType={userType}
                                            region={region}
                                        />
                                        {/* 榜单 & Banner, notice: 使用了css - mask属性 */}
                                        <BannerAndRank
                                            pageColor={pageColor}
                                            bannerList={bannerList}
                                            lang={lang}
                                            region={region}
                                            sellerTitleImg={background.sellerTitleImg}
                                            sellerTitleText={background.sellerTitleText}
                                            renderUserType={renderUserType}
                                            rankList={rankList}
                                        />
                                    </>
                                )
                                : (
                                    // 错误信息可以通过这里展示
                                    this.oldUserRender()
                                )
                        }
                        <ProductFlow
                            editConfig={this.props.editConfig}
                            expired={expired}
                            tabList={renderUserType === IUserType.seller ? sellerTabList :  buyerTabList}
                            renderUserType={renderUserType}
                            tabTextColorActive={tabTextColorActive}
                            tabTextColor={tabTextColor}
                            background={background}
                            tabItemTitleBg={tabItemTitleBg}
                            tabBgColor={tabBgColor}
                            tabCount={tabCount}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

PoizonNewUserCouponV3.config = {
    name: 'poizon-new-user-coupon',
}

export default PoizonNewUserCouponV3
